export default function initShowText() {
    const introText = document.querySelector('#intro-text');

    const yesText = document.querySelector('#yes-text');
    const yesButton = document.querySelector('#yes-button');

    const noText = document.querySelector('#no-text');
    const noButton = document.querySelector('#no-button');

    const featureText = document.querySelector('#feature-text');
    const featureButton = document.querySelector('#feature-button');

    const bugText = document.querySelector('#bug-text');
    const bugButton = document.querySelector('#bug-button');

    const dnsText = document.querySelector('#dns-text');
    const dnsButton = document.querySelector('#dns-button');

    const emailText = document.querySelector('#email-text');
    const emailButton = document.querySelector('#email-button');

    const otherText = document.querySelector('#other-text');
    const otherButton = document.querySelector('#other-button');

    function addEventListenersIntro(text, button) {
        button.addEventListener('mouseover', (e) => {
            introText.classList.add('opacity-0');
            text.classList.remove('opacity-0');
            text.classList.remove('cursor-default');
        });
        button.addEventListener('mouseleave', (e) => {
            introText.classList.remove('opacity-0');
            text.classList.add('opacity-0');
            text.classList.add('cursor-default');
        });
    }

    function addEventListeners(text, button) {
        button.addEventListener('mouseover', (e) => {
            text.classList.remove('opacity-0');
            text.classList.remove('cursor-default');
        });
        button.addEventListener('mouseleave', (e) => {
            text.classList.add('opacity-0');
            text.classList.add('cursor-default');
        });
    }

    addEventListenersIntro(yesText, yesButton);
    addEventListenersIntro(noText, noButton);
    addEventListeners(featureText, featureButton);
    addEventListeners(bugText, bugButton);
    addEventListeners(dnsText, dnsButton);
    addEventListeners(emailText, emailButton);
    addEventListeners(otherText, otherButton);
}
